<!-- 🌐 Tarjeta de perfil (mismo marcado en desktop, tablet y celular:
     el diseño y las animaciones se ajustan por CSS en cada breakpoint) -->
<header class="header sidebar">
  <!-- Foto de perfil -->
  <section class="profile-section">
    <div class="profile-pic">
      <img src="assets/images/fotografia4-w320.webp" width="320" height="480"
        alt="Natalia Güechá Nieto, psicóloga clínica, en su consulta en Bogotá">
    </div>
    <h2 class="name">Natalia Güechá</h2>
    <h3 class="role">Psicóloga Clínica </h3>
  </section>

  <!-- Info de contacto (NAP: nombre, dirección y teléfono, con enlaces tel:/mailto:) -->
  <section class="contact-info">
    <p><i class="fas fa-map-marker-alt" aria-hidden="true"></i> Bogotá, Colombia</p>
    <p><i class="fas fa-phone" aria-hidden="true"></i> <a href="tel:+573104671284">+57 310 4671284</a></p>
    <p><i class="fas fa-envelope" aria-hidden="true"></i> <a
        href="mailto:consultas@bienestarconnataliaguecha.com">consultas@<wbr>bienestarconnataliaguecha.com</a></p>
  </section>

  <!-- Botones de acción -->
  <nav class="action-buttons">
    <a href="https://www.instagram.com/psicologa.nataliaguecha/" target="_blank" class="btn contact-btn">
      <i class="fab fa-instagram"></i>
      <span class="btn-label">Instagram</span>
    </a>
    <a href="https://www.linkedin.com/in/natalia-güechá-nieto-91a636244/" target="_blank" class="btn linkedin-btn">
      <i class="fab fa-linkedin"></i>
      <span class="btn-label">LinkedIn</span>
    </a>
    <a href="https://wa.me/573104671284" target="_blank" class="btn whatsapp-btn">
      <i class="fab fa-whatsapp"></i>
      <span class="btn-label">Whatsapp</span>
    </a>
    <a href="https://www.tiktok.com/@psicologa.nataliaguecha" target="_blank" class="btn tiktok-btn">
      <i class="fab fa-tiktok"></i>
      <span class="btn-label">Tiktok</span>
    </a>
  </nav>
</header>
